import { Grid } from '@mui/material';
import React from 'react';
import TestCycleViewPage from '../../components/project-dashboard/test-cycles/TestCycleViewPage';
import DashboardLayout from '../../layout/dashboard/DashboardLayout';
import { useParams } from 'react-router-dom';

const TestCycleDetailsPage = () => {
  const { testCycleKey, projectId } = useParams();

  return (
    <DashboardLayout>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <TestCycleViewPage testCycleKey={testCycleKey} projectId={projectId} />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default TestCycleDetailsPage;
